import { useEffect, useState, useCallback } from "react";
import { getEventsForDate } from "@/lib/storage";

export function useDayEvents(dateISO) {
  const load = useCallback(() => getEventsForDate(dateISO), [dateISO]);
  const [events, setEvents] = useState(load);

  useEffect(() => {
    setEvents(load());
    const onChange = () => setEvents(load());
    window.addEventListener("chronicles:changed", onChange);
    window.addEventListener("storage", onChange);
    return () => {
      window.removeEventListener("chronicles:changed", onChange);
      window.removeEventListener("storage", onChange);
    };
  }, [load]);

  return events;
}
